"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayrollShiftOnCallDto = instanceOfPayrollShiftOnCallDto;
exports.PayrollShiftOnCallDtoFromJSON = PayrollShiftOnCallDtoFromJSON;
exports.PayrollShiftOnCallDtoFromJSONTyped = PayrollShiftOnCallDtoFromJSONTyped;
exports.PayrollShiftOnCallDtoToJSON = PayrollShiftOnCallDtoToJSON;
exports.PayrollShiftOnCallDtoToJSONTyped = PayrollShiftOnCallDtoToJSONTyped;
/**
 * Check if a given object implements the PayrollShiftOnCallDto interface.
 */
function instanceOfPayrollShiftOnCallDto(value) {
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    return true;
}
function PayrollShiftOnCallDtoFromJSON(json) {
    return PayrollShiftOnCallDtoFromJSONTyped(json, false);
}
function PayrollShiftOnCallDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'minutesWorked': json['minutesWorked'],
    };
}
function PayrollShiftOnCallDtoToJSON(json) {
    return PayrollShiftOnCallDtoToJSONTyped(json, false);
}
function PayrollShiftOnCallDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'minutesWorked': value['minutesWorked'],
    };
}
//# sourceMappingURL=PayrollShiftOnCallDto.js.map